import { Component } from '@grafikr/components';

import loadScript from 'utils/load-script';
import { NonNullish } from 'utils/nullish-check';

export default Component((node, { onMounted }) => {
  const loadSource = async () => {
    const properties = node.dataset.properties;
    await loadScript(NonNullish(node.dataset.url), properties ? JSON.parse(properties) : null);
  };

  const loadResponsiveSource = async () => {
    const mediaQuery = node.dataset.media;

    if (mediaQuery) {
      const matches = window.matchMedia(mediaQuery).matches;

      if (matches) {
        await loadSource();
      }
    } else {
      await loadSource();
    }
  };

  const init = async () => {
    if (!node.dataset.url) {
      throw new Error('Missing [data-url] property on node');
    }

    const placeholder = node.querySelector<HTMLElement>('[data-placeholder]');

    await loadResponsiveSource();

    if (placeholder) {
      node.removeChild(placeholder);
    }
  };

  onMounted(() => {
    init();
  });
});
